import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { authenticate } from 'state/modules/auth';
import { FormattedMessage } from 'react-intl';
import { Button } from 'vendor/heroui';

const googleButtonClassName = [
  'h-12 rounded-xl border border-[var(--owner-border)] bg-[var(--owner-surface)] font-semibold text-[var(--owner-text)] shadow-sm transition',
  'hover:bg-[var(--owner-surface-muted)]',
].join(' ');

const SingleSignOn = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const tenantId = useSelector(state => state.tenant.id);
  const tenantTheme = useSelector(state => state.tenant.theme);

  const handleAuthentication = authCode => {
    dispatch(authenticate('google', tenantId, authCode));
  };

  useEffect(() => {
    // Handle authentication callback. Client should've returned with code when authentication was okay
    const code = new URLSearchParams(location.search).get('code');
    if (code) {
      dispatch(authenticate('google', tenantId, code));
      // Remove only OAuth callback params so a refresh doesn't re-trigger, but preserve others (e.g. nextURL)
      const params = new URLSearchParams(location.search);
      ['code', 'state', 'scope', 'authuser', 'prompt', 'error', 'error_description'].forEach(key => params.delete(key));
      const remaining = params.toString();
      window.history.replaceState({}, '', location.pathname + (remaining ? `?${remaining}` : '') + location.hash);
    }
  }, [dispatch, tenantId, location.search]);

  const buttonColor = tenantTheme?.a?.color || tenantTheme?.colors?.primary;
  const googleButtonStyle = {
    background: 'transparent',
    color: buttonColor,
  };

  return (
    <div className="mx-auto w-full max-w-sm">
      {/*
        // TODO OWN-5: Hide Facebook SSO login before Gateway API is ready
        <Button color="facebook" style={{ minWidth: '160px' }} onClick={() => dispatch(authenticate('facebook', tenantId))}>
          <Icon name="facebook" />
          <FormattedMessage id="page.login.label.facebook" />
        </Button>
      */}
      <Button
        fullWidth
        size="lg"
        variant="secondary"
        className={googleButtonClassName}
        onPress={() => handleAuthentication()}
        style={googleButtonStyle}
      >
        <img
          alt=""
          src="/google-24.png"
          className="mr-3 inline-block h-5 w-5 align-middle"
        />
        <span>
          <FormattedMessage id="page.login.label.google" />
        </span>
      </Button>
    </div>
  );
};

export default SingleSignOn;
